module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-15.201f97a9.png";